import http from '@utils/http';

/**
 * GET /api/v1/public/categories-and-tags
 * Returns: { categories: Array<{id,name,sortOrder}>, tags: Array<{id,tag}> }
 */
export const getCategoriesAndTags = () =>
    http.get('/public/categories-and-tags').then((res) => res.data?.data ?? res.data);

